module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[32]397.dc25a25.woff2";